export default ({ request }) => ({
  orderTechPricingListApi(data = {}) {
    return request({
      url: '/factory/mrp/order/tech/pricing/list',
      method: 'post',
      data
    })
  },
  orderTechPricingDetailApi(data = {}) {
    return request({
      url: '/factory/mrp/order/tech/pricing/detail',
      method: 'post',
      data
    })
  },
  orderTechPricingSaveApi(data = {}) {
    return request({
      url: '/factory/mrp/order/tech/pricing/save',
      method: 'post',
      data
    })
  },
  orderTechPricingDelApi(data = {}) {
    return request({
      url: '/factory/mrp/order/tech/pricing/del',
      method: 'post',
      data
    })
  },
  orderTechPricingDelCheckApi(data = {}) {
    return request({
      url: '/factory/mrp/order/tech/pricing/del/check',
      method: 'post',
      data
    })
  },
  orderTechPricingAuditApi(data = {}) {
    return request({
      url: '/factory/mrp/order/tech/pricing/audit',
      method: 'post',
      data
    })
  },
  orderTechPricingGoodsListApi(data = {}) {
    return request({
      url: '/factory/mrp/order/tech/pricing/goodsList',
      method: 'post',
      data
    })
  },
  orderTechPricingGoodsSpecSaveApi(data = {}) {
    return request({
      url: '/factory/mrp/order/tech/pricing/specSave',
      method: 'post',
      data
    })
  },
  orderTechPricingGoodsSpecDetailApi(data = {}) {
    return request({
      url: '/factory/mrp/order/tech/pricing/specDetail',
      method: 'post',
      data
    })
  },
  orderTechPricingGoodsSpecListApi(data = {}) {
    return request({
      url: '/factory/mrp/order/tech/pricing/specList',
      method: 'post',
      data
    })
  },
  orderTechPricingCopyApi(data = {}) {
    return request({
      url: '/factory/mrp/order/tech/pricing/copy',
      method: 'post',
      data
    })
  },
  orderTechPricingAuditSaveApi(data = {}) {
    return request({
      url: '/factory/mrp/order/tech/pricing/audit/save',
      method: 'post',
      data
    })
  },
})
